import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import { useEffect } from "react";
import WaterBuildingInfoComponent from "./waterBuildingInfoComponent";

const WaterBuildingInfoCheckModal = ({ isOpen, onClose, building }: any) => {

    useEffect(() => { console.log(building) }, [])

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="5xl"
            shouldBlockScroll={true}
            isDismissable={true}
            scrollBehavior="inside"
            backdrop="blur"
            className="p-8"
        >
            <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
                <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
                    <p>{building.id} - Waterhuishouding</p>
                </ModalHeader>
                <ModalBody className="px-0">
                    <WaterBuildingInfoComponent
                        waterSystemInfo={{ ...building?.waterBuildingInfo, buildingId: building.id}}
                        building={building}
                        handleCloseParent={onClose}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default WaterBuildingInfoCheckModal;
